import { useEffect, useState } from 'react'

/** How long a session may take to arrive before its pane stops looking like one. */
export const SESSION_ARRIVAL_GRACE_MS = 8000

/** True once `missing` has held for the whole grace period; false again the
 *  moment it stops. */
export function useNotArrived(missing: boolean): boolean {
  const [late, setLate] = useState(false)
  useEffect(() => {
    setLate(false)
    if (!missing) return
    const timer = setTimeout(() => setLate(true), SESSION_ARRIVAL_GRACE_MS)
    return () => clearTimeout(timer)
  }, [missing])
  return late && missing
}
